/**
 * Sanitiza um objeto de erro para torná-lo seguro para armazenamento no Redux ou logs.
 * Remove propriedades não serializáveis e mantém apenas os dados úteis.
 */
export function sanitizeError(input: unknown = {}): Record<string, any> {
  try {
    // Converte para um objeto JSON puro, eliminando funções, símbolos e referências circulares
    return JSON.parse(JSON.stringify(input))
  } catch {
    // Se houver erro na serialização (ex: referência circular), retorna um fallback simplificado
    return {
      message: (input as any)?.message || 'Erro desconhecido',
      name: (input as any)?.name || 'UnknownError',
    }
  }
}
